import * as types from 'modules/cameras/actionTypes';
import type {
  FetchCamerasSuccessAction,
  FetchCameraScansSuccessAction,
  StoredCamera,
} from 'modules/cameras/types';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';
import type { EntitySlice } from 'utils/ReduxUtils';

export const cameraAdapter = createEntityAdapter<StoredCamera>({ selectId: ({ id }) => id });

const updateManyFromPage = (state: EntitySlice<StoredCamera>, { payload }: FetchCamerasSuccessAction) =>
  cameraAdapter.updateMany(state, payload.content);

const updateCameraScans = (state: EntitySlice<StoredCamera>, { payload }: FetchCameraScansSuccessAction) =>
  cameraAdapter.updateOne(state, { scans: payload.scans, id: payload.cameraId });

export default createReducer(cameraAdapter.getInitialState(), {
  [types.FETCH_CAMERAS_SUCCESS]: updateManyFromPage,
  [types.PUT_CAMERA_SUCCESS]: cameraAdapter.addOne,
  [types.POST_CAMERA_SUCCESS]: cameraAdapter.addOne,
  [types.FETCH_CAMERA_SUCCESS]: cameraAdapter.addOne,
  [types.PATCH_STATUS_SUCCESS]: cameraAdapter.updateOne,
  [types.POST_CAMERA_TV_PAIRING_SUCCESS]: cameraAdapter.updateOne,
  [types.POST_CAMERA_TV_UNPAIRING_SUCCESS]: cameraAdapter.updateOne,
  [types.DELETE_SUCCESS]: cameraAdapter.removeOne,
  [types.FETCH_CAMERA_SCANS_SUCCESS]: updateCameraScans,
});
